import { faqItems } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-4">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-lg border border-background-200/80 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors list-none">
                <span>{item.question}</span>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}